import React from "react";
import { Link } from "react-router-dom";
import { PageSection } from "@/components/AppLayout.jsx";
import { useKarateUi } from "@/hooks/useKarateUi.js";
import { useAuth } from "@/context/AuthContext.jsx";

export function SenseiGuard({ children }) {
  const auth = useAuth();
  const { ui } = useKarateUi();
  const guard = ui.guard;

  if (auth.role !== "sensei") {
    return (
      <PageSection title={guard.title} testId="page-sensei-denied">
        <p>
          {guard.denied} <Link to="/connexion">{guard.login}</Link>
        </p>
      </PageSection>
    );
  }
  return children;
}
